import {useEffect, useMemo, useState} from 'react'
import useControlledTableProperty from '../Utils/useControlledTableProperty'

const usePagination = ({table, dataLength, showPagination, pageSizeOptions, pagination: propsPagination, defaultPageSize, userStateKey, onPaginationChange}) => {
  const [haveWarnedAboutPageSize, setHaveWarnedAboutPageSize] = useState(false)
  
  const defaultPagination = useMemo(() => {
    const defaultPagination = {}
    if(pagination?.pageIndex || pagination?.pageIndex === 0) {
      defaultPagination.pageIndex = pagination.pageIndex
    } else {
      defaultPagination.pageIndex = 0
    }

    if(pagination?.pageSize) {
      defaultPagination.pageSize = pagination.pageSize
    } else if(defaultPageSize) {
      defaultPagination.pageSize = defaultPageSize
    } else if(pageSizeOptions?.length > 0) {
      defaultPagination.pageSize = pageSizeOptions[0]
    } else {
      defaultPagination.pageSize = 20
    }

    if (!pageSizeOptions.find(option => option === defaultPagination.pageSize)) {
      defaultPagination.pageSize = pageSizeOptions[0]
    }

    return defaultPagination
  }, [pagination?.pageIndex, pagination?.pageSize, defaultPageSize, pageSizeOptions])

  const [pagination, setPagination] = useControlledTableProperty({
    initialValue: defaultPagination,
    controlledValue: propsPagination,
    name: 'pagination',
    onChangeFn: onPaginationChange
  })

  useEffect(() => {
    if (!pageSizeOptions.find(option => option === defaultPagination.pageSize)) {
      if (!haveWarnedAboutPageSize) {
        const tableName = userStateKey || ''
        console.warn(
          `XtractTable "${tableName}" specifies a default page size to be ${defaultPagination.pageSize} and it is not in the list of page size options.`
        )
        setHaveWarnedAboutPageSize(true)
      }
    }
  },[pageSizeOptions, defaultPagination.pageSize])

  useEffect(() => {
    setPagination(defaultPagination)
    // the dependencies need to call out the individual parts of defaultPagination
    // since the defaultPagination object is recomputed on every pass so even though
    // the contents may be the same, the object reference is different which would
    // trigger an update
  }, [defaultPagination.pageSize, defaultPagination.pageIndex, table])

  useEffect(() => {
    if (!showPagination) {
      table?.setPageSize(dataLength)
    }
  }, [dataLength, showPagination])

  return {
    setPagination,
    pagination
  }
}

export default usePagination